/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName } from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';
import {
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSONTyped,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON,
} from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName';
import type { ExecRiskUSAddress } from './ExecRiskUSAddress';
import {
    ExecRiskUSAddressFromJSON,
    ExecRiskUSAddressFromJSONTyped,
    ExecRiskUSAddressToJSON,
} from './ExecRiskUSAddress';

/**
 * 
 * @export
 * @interface ExecRiskFiler
 */
export interface ExecRiskFiler {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskFiler
     */
    EIN: string;
    /**
     * 
     * @type {ExecRiskUSAddress}
     * @memberof ExecRiskFiler
     */
    USAddress?: ExecRiskUSAddress;
    /**
     * 
     * @type {ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName}
     * @memberof ExecRiskFiler
     */
    BusinessName?: ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessName;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskFiler
     */
    BusinessNameControlTxt?: string;
}

/**
 * Check if a given object implements the ExecRiskFiler interface.
 */
export function instanceOfExecRiskFiler(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "EIN" in value;

    return isInstance;
}

export function ExecRiskFilerFromJSON(json: any): ExecRiskFiler {
    return ExecRiskFilerFromJSONTyped(json, false);
}

export function ExecRiskFilerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskFiler {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'EIN': json['EIN'],
        'USAddress': !exists(json, 'USAddress') ? undefined : ExecRiskUSAddressFromJSON(json['USAddress']),
        'BusinessName': !exists(json, 'BusinessName') ? undefined : ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameFromJSON(json['BusinessName']),
        'BusinessNameControlTxt': !exists(json, 'BusinessNameControlTxt') ? undefined : json['BusinessNameControlTxt'],
    };
}

export function ExecRiskFilerToJSON(value?: ExecRiskFiler | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'EIN': value.EIN,
        'USAddress': ExecRiskUSAddressToJSON(value.USAddress),
        'BusinessName': ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesBusinessNameToJSON(value.BusinessName),
        'BusinessNameControlTxt': value.BusinessNameControlTxt,
    };
}

